import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { FormStateService } from "src/app/Services/form.service";

@Component({
  selector: "app-set-password",
  templateUrl: "./set-password.component.html",
  standalone: false,
})
export class SetPasswordComponent implements OnInit {
  token: string;
  uid: string;
  form: UntypedFormGroup;
  submitted = false;

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private http: HttpClient,
    private router: Router,
    private formStateService: FormStateService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"];
      this.uid = params["uid"];
    });

    this.form = this.formBuilder.group({
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$"
          ),
        ],
      ],
      confirmPassword: ["", [Validators.required, this.passwordValidator()]],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });
  }

  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;

      if (!formGroup) {
        return null;
      }

      const password = formGroup.get("password").value;
      const confirmPassword = formGroup.get("confirmPassword").value;

      let match = false;

      match = password !== confirmPassword;

      if (match) {
        return { match: true };
      }

      return null;
    };
  }

  get f() {
    return this.form.controls;
  }

  resetPassword(newPassword: string) {
    const headers = new HttpHeaders({
      Authorization: this.token,
    });

    return this.http
      .patch<any>(
        "/api/userManagements/reset-password?access_token=" +
          this.token +
          "&uid=" +
          this.uid,
        { newPassword: newPassword },
        { headers: headers }
      )
      .subscribe(
        (response) => {
          if (
            response.result &&
            response.result.message == "password_updated_successfully"
          ) {
            this.toastr.success("New password set successfully.", "Success");
          } else if (
            response.error &&
            response.error.error &&
            response.error.error.message == "INVALID_TOKEN"
          ) {
            this.toastr.error(
              "The reset link is invalid or has expired. Please request a new one.",
              "Invalid link"
            );
          }
          // console.log(response);
        },
        (errorResponse) => {
          if (
            errorResponse.error &&
            errorResponse.error.error &&
            errorResponse.error.error.message == "INVALID_TOKEN"
          ) {
            this.toastr.error(
              "The reset link is invalid or has expired. Please request a new one.",
              "Invalid link"
            );
          } else if (
            errorResponse.error &&
            errorResponse.error.error &&
            errorResponse.error.error.message == "INVALID_USER"
          ) {
            this.toastr.error(
              "No user account associated with the provided details.",
              "User not found"
            );
          }
        }
      );
  }

  onSubmit() {
    this.submitted = true;
    var self = this;
    if (self.form.invalid) return;

    var password = self.form.value.password;
    self.resetPassword(password);
    self.formStateService.clearFormDirty();
    self.router.navigate(["/"]);
  }

  onReset() {
    this.submitted = false;
    this.form.reset();
    this.formStateService.clearFormDirty();
  }
}
